export default __webpack_public_path__ + "static/media/record-player.bb60ed72.png";